import type { RouteRecordRaw } from 'vue-router'
import { MY_ROUTES } from '@/router/routes.enum'
import { requireAuthenticated, requireReservationsEnabled } from '@/router/guards'

export const reservationRoutes: RouteRecordRaw[] = [
  {
    path: 'reservations',
    beforeEnter: [requireReservationsEnabled, requireAuthenticated],
    children: [
      {
        path: '',
        name: MY_ROUTES.RESERVATIONS,
        component: () => import('@/my/modules/reservations/views/ReservationListing.view.vue')
      },
      {
        path: ':id/reschedule',
        name: MY_ROUTES.RESERVATIONS_RESCHEDULE,
        component: () => import('@/my/modules/reservations/views/ReservationReschedule.view.vue')
      },
      {
        path: ':id/confirmation',
        name: MY_ROUTES.RESERVATIONS_RESCHEDULE_CONFIRMATION,
        component: () =>
          import('@/my/modules/reservations/views/ReservationRescheduleConfirmation.view.vue')
      }
    ]
  }
]
